import React, { useState } from 'react';
import { Container, Row, Col, Button, Modal, Form, Card } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import DataTable from 'react-data-table-component';
import '../styles/style.css'; // Custom styles
import NavBar from './Navbar';

function AdminDashboard({ user, onLogout }) {
  const [users, setUsers] = useState([
    { id: 1, name: 'John Doe', email: 'john@example.com', role: 'user' },
    { id: 2, name: 'Jane Smith', email: 'jane@example.com', role: 'admin' },
    { id: 3, name: 'Alice Johnson', email: 'alice@example.com', role: 'user' },
    { id: 4, name: 'Jane Smith', email: 'jane@example.com', role: 'admin' },
    { id: 5, name: 'Alice Johnson', email: 'alice@example.com', role: 'user' },
    { id: 6, name: 'Jane Smith', email: 'jane@example.com', role: 'admin' },
    { id: 7, name: 'Alice Johnson', email: 'alice@example.com', role: 'user' },
    { id: 8, name: 'Jane Smith', email: 'jane@example.com', role: 'admin' },
    { id: 9, name: 'Alice Johnson', email: 'alice@example.com', role: 'user' },
  ]);

  const [showModal, setShowModal] = useState(false);
  const [currentUser, setCurrentUser] = useState({ id: null, name: '', email: '', role: 'user' });
  const [searchText, setSearchText] = useState('');

  const handleShowModal = (user = { id: null, name: '', email: '', role: 'user' }) => {
    setCurrentUser(user);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCurrentUser(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    const updatedUsers = currentUser.id
      ? users.map(user => user.id === currentUser.id ? currentUser : user)
      : [...users, { ...currentUser, id: users.length + 1 }];
    setUsers(updatedUsers);
    handleCloseModal();
  };

  const handleDeleteUser = (userId) => {
    setUsers(users.filter(user => user.id !== userId));
  };

  const columns = [
    { name: '#', selector: row => row.id, sortable: true },
    { name: 'Name', selector: row => row.name, sortable: true },
    { name: 'Email', selector: row => row.email, sortable: true },
    { name: 'Role', selector: row => row.role, sortable: true },
    {
      name: 'Actions',
      cell: row => (
        <>
          <Button variant="primary" size="sm" className="me-2" onClick={() => handleShowModal(row)}>
            <i className="bi bi-pencil-fill"></i>
          </Button>
          <Button variant="danger" size="sm" onClick={() => handleDeleteUser(row.id)}>
            <i className="bi bi-trash-fill"></i>
          </Button>
        </>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  return (
    <>
        <NavBar user={user} onLogout={onLogout} />
    <Container fluid>
      <div className="navbar-margin">
            
            </div>
      
      <Row>
        <Col>
          <Card className="shadow-sm">
            <Card.Body>
              <div className="header-with-button">
                <h3>User List</h3>
                <Button variant="primary" onClick={handleShowModal}>Add User</Button>
              </div>
              <DataTable
                columns={columns}
                data={users.filter(user =>
                  user.name.toLowerCase().includes(searchText.toLowerCase()) ||
                  user.email.toLowerCase().includes(searchText.toLowerCase()) ||
                  user.role.toLowerCase().includes(searchText.toLowerCase())
                )}
                pagination
                highlightOnHover
                striped
                responsive
                customStyles={{
                  headRow: {
                    style: {
                      backgroundColor: '#deedfd', // Gradient blue header
                      color: 'black',
                      fontSize: '16px',
                      fontWeight: 'bold',
                    },
                  },
                  rows: {
                    style: {
                      fontSize: '14px',
                      '&:hover': {
                        backgroundColor: '#f5f5f5', // Light gray on hover
                      },
                    },
                  },
                  pagination: {
                    style: {
                      borderTop: '1px solid #e0e0e0',
                    },
                  },
                }}
                subHeader
                subHeaderComponent={
                  <input
                    type="text"
                    placeholder="Search..."
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    className="form-control w-25"
                  />
                }
              />
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>{currentUser.id ? 'Edit User' : 'Add User'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Full Name</Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={currentUser.name}
                onChange={handleInputChange}
                placeholder="Enter name"
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={currentUser.email}
                onChange={handleInputChange}
                placeholder="Enter email"
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Role</Form.Label>
              <Form.Select
                name="role"
                value={currentUser.role}
                onChange={handleInputChange}
              >
                <option value="user">User</option>
                <option value="admin">Admin</option>
              </Form.Select>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>Close</Button>
          <Button variant="primary" onClick={handleSubmit}>{currentUser.id ? 'Update User' : 'Add User'}</Button>
        </Modal.Footer>
      </Modal>
    </Container>
    </>
  );
}

export default AdminDashboard;
